/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap-v5'
import * as AbilitiesCRUD from '../../abilities/AbilitiesCRUD';
import { ABILITIES_TYPES, PAYMENT_VOUCHER } from '../../../constants/common';
import PaymentVoucherTable from '../../abilities/agency/PaymentVoucherTable';
import { PaginateModel } from '../../../models/PaginateModel';
import { HeaderModel, ModalModel } from '../../../models/CommonModel';
import { useIntl } from 'react-intl';
import ConsignmentSupplierTable from './ConsignmentSupplierTable';
import { ConsignSupplierModel, SearchModel } from '../../../modules/auth/models/ConsignmentsModel';
import { connectConsignSupplier, getConsignSupplierList } from '../StoreCRUD';
import { Toast } from '../../../modules/common/helper';

type Props = {
    show: boolean
    data?: any
    mode: string
    onClose: () => void
}
const ConsignmentSupplierModal: React.FC<Props> = ({ show, data, onClose }) => {
   
    const [dataPaginate, setDataPaginate] = useState<PaginateModel<ConsignSupplierModel>>();
    const initSearch = {
    }
    const intl = useIntl();
    const [hideCols, setHideCols] = useState<string[]>([]);
    const [selected, setSelected] = useState<number[]>([]);
    const [configModal, setConfigModal] = useState<ModalModel>({
        show: false,
        mode: 'add',
    });
    const [search, setSearch] = useState<SearchModel>(initSearch)
    const header: HeaderModel[] = [
        {
            label: 'Tên NCC',
            style: { minWidth: "150px" },
            field: 'name',
            sortable: true
        },
        {
            label: 'Thông tin liên lạc',
            style: { minWidth: "250px" },
            field: 'contact_info',
            sortable: false
        },
        {
            label: 'MST',
            style: { minWidth: "100px" },
            field: 'tax_code',
            sortable: false
        }
    ]

    useEffect(() => {
        if (data?.store_id) {
            getData({...search, store_id: data?.store_id});
        }
    }, [data]);

    const getData = async (params?: SearchModel) => {
        const { data: resData } = await  getConsignSupplierList(params);
        setDataPaginate(resData);
        setSearch(params ?? {});
    }

    const handleSearch = (e: any) => {
        e.preventDefault();
        getData({ ...search, page: 1 })
    }

    const handleClearSearch = (e: any) => {
        e.preventDefault();
        setSearch(initSearch);
      
        getData(initSearch)
    }

    const handleSort = (sortBy: string, direction: 'asc' | 'desc' | 'none') => {
        const currentSearch = { ...search };
        const sortParams: SearchModel = { ...currentSearch, sort_by: sortBy, sort_direction: direction };
        if (direction === 'none') {
            delete sortParams.sort_by;
            delete sortParams.sort_direction;
        }
        getData({ ...sortParams });
    }

    const handleChangeVisCols = (e: any) => {
        let hiddenCols = [...hideCols];
        if (!e.target?.checked) {
            setHideCols([...hiddenCols, e.target.name])
        } else {
            setHideCols(hiddenCols.filter((item) => item !== e.target.name))
        }
    }

    const handleConnect = async () => {
        if (!selected || selected.length === 0) {
            Toast.fire({
                icon: 'error',
                title: 'Vui lòng chọn ncc'
            });
        }
        try {
            await connectConsignSupplier(data.store_id, selected);
            Toast.fire({
                icon: 'success',
                title: 'Cập nhật thành công'
            });
            getData({ ...search });
            setSelected([]);
        } catch (error: any) {
           Toast.fire({
                icon: 'error',
                title: 'Đã có lỗi vui lòng thử lại sau'
            });
        }
    }
    return (
        <Modal
            show={show}
            onHide={onClose}
            aria-labelledby='contained-modal-title-vcenter'
            centered
            size='xl'
        >
            <Modal.Header className='d-flex'>
                <Modal.Title>{ data?.supplier?.name }</Modal.Title>
            </Modal.Header>
            <Modal.Body className="px-10">
                <div className="card">
                    <div className="card-header py-4">
                        <div className="col-md-12">
                           
                                <div className="row">
                                    <div className="col-md-2">
                                        <label className="form-label">Từ khóa</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder=""
                                            name="keyword"
                                            value={search.keyword || ''}
                                            onChange={(e) => setSearch({ ...search, keyword: e.target.value })}
                                            autoComplete='nope'
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <div className="row">
                                            <button
                                                className="col-auto btn btn-primary mt-8 me-2"
                                                onClick={handleSearch}
                                            >
                                                <i className="bi bi bi-search fs-4"></i>
                                            </button>
                                            <button
                                                className="col-auto btn btn-danger mt-8 me-2"
                                                type="button"
                                                onClick={handleClearSearch}
                                            >
                                                <i className="bi bi-eraser-fill fs-1"></i>
                                            </button>
                                        </div>

                                    </div>
                                </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className='row justify-content-end text-end'>
                            <div className='btn-groups mb-3'>
                                <button
                                    className="col-auto btn btn-sm btn-primary me-2"
                                    disabled={!selected || selected.length === 0}
                                    type="button"
                                    onClick={handleConnect}
                                >
                                    Kết nối
                                </button>
                            </div>
                        </div>
                        <ConsignmentSupplierTable
                            data={dataPaginate?.data || []}
                            openColConfig={() => setConfigModal({ ...configModal, show: true })}
                            header={header}
                            hideCols={hideCols}
                            handleSort={handleSort}
                            hideConfig={true}
                            selected={selected}
                            setSelected={setSelected}
                        />
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default ConsignmentSupplierModal
